import {useEffect} from "react";
import {useLocation} from "react-router-dom";

/**
 * Resets the window scroll position to the top whenever the route path changes.
 *
 * react-router v5 keeps the previous scroll offset across navigations, so
 * without this, clicking a link while scrolled down opens the next page
 * mid-content instead of at the start.
 *
 * Keyed on `pathname` only (not `hash` or `search`), so in-page anchor
 * scrolling (e.g. the hero "See the solutions" jump) and query-string updates
 * are left untouched. Renders nothing.
 */
function ScrollToTop(): null {
  const {pathname, hash} = useLocation();

  useEffect(() => {
    // If the URL points at an anchor (e.g. /page#section), let the browser jump
    // to that element instead of forcing the top.
    if (hash) {
      return;
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}

export default ScrollToTop;
